import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.shipmentView.shippingMethodSection.title',
    defaultMessage: 'Shipping method',
    description: 'title of the shipping method section',
  },
  shippingMethodSection: {
    overview: {
      name: {
        id: 'pages.shipmentView.shippingMethodSection.overview.name',
        defaultMessage: 'Name',
        description: 'title of the name in the shipping method section',
      },
      description: {
        id: 'pages.shipmentView.shippingMethodSection.overview.description',
        defaultMessage: 'Description',
        description: 'title of the description in the shipping method section',
      },
      deliveryDuring: {
        id: 'pages.shipmentView.shippingMethodSection.overview.deliveryDuring',
        defaultMessage: 'Delivery during',
        description: 'title of the delivery during in the shipping method section',
      },
      isSameDay: {
        id: 'pages.shipmentView.shippingMethodSection.overview.isSameDay',
        defaultMessage: 'Same day delivery',
        description: 'title of the is same day in the shipping method section',
      },
      isSunday: {
        id: 'pages.shipmentView.shippingMethodSection.overview.isSunday',
        defaultMessage: 'Delivered on sunday',
        description: 'title of the is sunday in the shipping method section',
      },
      isCarrierLocation: {
        id: 'pages.shipmentView.shippingMethodSection.overview.isCarrierLocation',
        defaultMessage: 'Carrier location',
        description: 'title of the is carrier location in the shipping method section',
      },
      isNeighbourAllowed: {
        id: 'pages.shipmentView.shippingMethodSection.overview.isNeighbourAllowed',
        defaultMessage: 'Neighbour allowed',
        description: 'title of the is neighbour allowed in the shipping method section',
      },
      yes: {
        id: 'app.yes',
        defaultMessage: 'Yes',
        description: 'Yes',
      },
      no: {
        id: 'app.no',
        defaultMessage: 'No',
        description: 'No',
      },
      deliveryDuringOptions: {
        daytime: {
          id: 'deliveryDuringOptions.daytime',
          defaultMessage: 'Daytime',
          description: 'title of the day time option in the shipping method section',
        },
      },
    },
    emptyMessage: {
      id: 'pages.shipmentView.shippingMethodSection.emptyMessage',
      defaultMessage: 'No shipping method',
      description: 'Empty message of the shipping method section',
    },
  },
};

export default defineMessages(translations);
